import { FetchEndpoint } from 'utils/endpoint/FetchEndpoint';

import { ApiUserLocation } from './types/ApiUserLocation';

type ApiResponse = {
  location: ApiUserLocation;
};

function mapResponse(response: ApiResponse) {
  return response.location;
}

const endpoint = new FetchEndpoint({
  urlFactory: () => `/data/user-location`,
  mapResponse,
});

// Exports

export const useApiFetchUserLocation = endpoint.createUseFetchHook();
